import NoticeApi from '@apis/notice/NoticeApi';
import noticeQueries from '@apis/queries/noticeQueries';
import { GetNoticesParams } from '@models/notice';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/pageable';

function useNotices() {
    const params: Omit<GetNoticesParams, 'page'> = { size: 10 };
    const queryInfo = useInfiniteQuery({
        queryKey: noticeQueries.list(params).queryKey,
        queryFn: ({ pageParam }) => NoticeApi.getNotices({
            ...params, page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });
    const notices = getFlattenPageResponse(queryInfo);
    const isBlank = getIsBlank(queryInfo);
    return {
        ...queryInfo,
        notices,
        isBlank,
    };
}

export default useNotices;
